import { Dispatch, SetStateAction, useMemo } from "react"
import { useSubscription } from "react-relay"
import { graphql, GraphQLSubscriptionConfig } from "relay-runtime"
import {
  useLeadsOnDutySubscription as useLeadsOnDutySubscriptionType,
  useLeadsOnDutySubscription$data,
} from "@/modules/leads-on-duty/services/__generated__/useLeadsOnDutySubscription.graphql"

const subscription = graphql`
  subscription useLeadsOnDutySubscription {
    leadsOnDutyChanged {
      medicalSupervisors {
        id
        firstName
        lastName
      }
      operationsLeads {
        id
        firstName
        lastName
      }
    }
  }
`

const useLeadsOnDutySubscription = (
  setLeadsOnDuty: Dispatch<SetStateAction<useLeadsOnDutySubscription$data | null | undefined>>,
) => {
  const subscriptionConfig: GraphQLSubscriptionConfig<useLeadsOnDutySubscriptionType> = useMemo(
    () => ({
      variables: {},
      subscription,
      onError: (error: Error) => console.error(`An error occurred while subscribe to LeadsOnDuty:`, error),
      onNext(response) {
        setLeadsOnDuty(response)
      },
    }),
    [setLeadsOnDuty],
  )

  return useSubscription<useLeadsOnDutySubscriptionType>(subscriptionConfig)
}

export { useLeadsOnDutySubscription }
